import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["playlistId", "portalId", "assignmentIds", "children", "tooltipProps"];
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAssignPlaylistUrl } from '../playlistAssignmentsRouting';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UsageTracker from '../../../utils/UsageTracker';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AssignPlaylistButton = _ref => {
  let {
      playlistId,
      portalId,
      assignmentIds,
      children = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlistAssignments.assignPlaylist"
      }),
      tooltipProps
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleClick = useCallback(() => {
    UsageTracker.track('playlistInteraction', {
      action: assignmentIds ? 'playlist-due-date-update' : 'assign-playlist-clicked',
      playlistId,
      portalId
    });
  }, [assignmentIds, playlistId, portalId]);
  return /*#__PURE__*/_jsx(UITooltip, Object.assign({
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.assignPlaylistTooltip"
    })
  }, tooltipProps, {
    children: /*#__PURE__*/_jsx(UIRouterButton, Object.assign({
      onClick: handleClick,
      to: getAssignPlaylistUrl({
        playlistId,
        portalId,
        assignmentIds
      }),
      use: "tertiary-light"
    }, props, {
      children: children
    }))
  }));
};